/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React, { ReactNode, useCallback } from "react";
import radioPadStyle from "./radioPadStyle";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { Button, FormControl } from "@mui/material";

type PadProps = {
  type: "checkbox" | "radio";
  active: boolean;
  error: boolean;
  optionHintText?: string | ReactNode | null;
  labelIcon: ReactNode;
  labelIconActive?: ReactNode;
  labelText: string;
  name: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  value?: string;
};
export default function Pad({ optionHintText = "", labelIcon, labelIconActive, labelText, name, onChange, value, active, error, type }: PadProps) {
  const getPaperStyle = useCallback((active: boolean, error: boolean) => {
    if (active) {
      return radioPadStyle.activePad;
    }
    if (error) {
      return radioPadStyle.errorPad;
    }
    return {};
  }, []);

  return (
    <FormControl sx={radioPadStyle.wrapper}>
      <Button
        sx={{
          all: "unset",
          display: "block",
          width: "100%",
          borderRadius: "25px",
        }}
        onClick={() =>
          onChange({
            target: {
              name: name + (type === "checkbox" ? "." + value : ""),
              value: value,
            },
          } as React.ChangeEvent<HTMLInputElement>)
        }
      >
        <Paper elevation={4} sx={{ ...radioPadStyle.paper, ...getPaperStyle(active, error) }}>
          <Grid container>
            <Grid
              sx={{ ...radioPadStyle.labelIcon, ...(active ? radioPadStyle.activeColor : {}) }}
              size={12}>
              {active && labelIconActive ? labelIconActive : labelIcon}
            </Grid>
            <Grid
              sx={{ ...radioPadStyle.labelText, ...(active ? radioPadStyle.activeColor : {}) }}
              size={12}>
              {labelText}
            </Grid>
            {optionHintText && (
              <Grid sx={radioPadStyle.optionHintText} size={12}>
                {optionHintText}
              </Grid>
            )}
          </Grid>
        </Paper>
      </Button>
    </FormControl>
  );
}
